import React, {Component} from "react";
import {setDoctorProfileSkeleton} from "./../../skeleton";
import ServiceCard from "./ServiceCard";
import NoData from "../NoData";
import InsCompanyCard from "./InsCompanyCard";
import {withTranslate} from "react-redux-multilingual";
import Accordion from "../Accordion";
import ProfileGallery from "./ProfileGallery";
import Rating from "react-rating";
import Review from "./Review";

class DoctorDetails extends Component {
    constructor(props) {
        super(props);
    }

    state = {
        numOfSubSpecialty: 5,
    };

    handleScrollToReviews = (e) => {
        e.preventDefault();
        const element = document.getElementById("reviews");
        if (element) {
            element.scrollIntoView();
        }
    };

    render() {
        const {currentDoctorIsLoading, doctor, doctorReviews, reviewsLoading, noMoreReviews, translate} = this.props;
        const reviews = doctorReviews && doctorReviews.length ? doctorReviews.map((review, index) => {
            return (
                <div key={index}>
                    <Review language={this.props.language} review={review}/>
                    <hr hidden={(index + 1) === doctorReviews.length}/>
                </div>
            )
        }) : null;
        const servicesList = doctor && doctor.services.length ? doctor.services.slice(0, this.props.numOfServices).map((service, index) => {
            return (
                <div id="service" key={index}>
                    <ServiceCard language={this.props.language} service={service} doctor={doctor}/>
                </div>
            )
        }) : (<NoData image="services"/>);

        const incCompanies = doctor && doctor.insurance_companies.length ? doctor.insurance_companies.slice(0, this.props.numOfIncCompanies).map((company, index) => {
                return (
                    <span className="tags" key={index}>
                      <InsCompanyCard company={company}/>
                   </span>
                )
            }
        ) : (<NoData image="insurance-company"/>);
        return (
            <div className="about-author flex-item" id="about-author">
                {
                    !currentDoctorIsLoading ? (
                            <div>
                                {doctor && doctor.bio !== "No Data To Show" ?
                                    <div className="row">
                                        <div className="col-md-12 no-padding">
                                            <Accordion box="biography">
                                                {doctor.bio}
                                            </Accordion>
                                        </div>
                                    </div> : null}
                                {doctor && doctor.services && doctor.services.length ?
                                    <div className="row">
                                        <div className="col-md-12 no-padding">
                                            <Accordion box="services">
                                                {servicesList}

                                                <p className=" text-center cursor-pointer bolder dark-blue "
                                                   hidden={doctor.services.length < this.props.numOfServices || doctor.services.length === 3}
                                                   onClick={(e) => this.props.toggleShowMore(e, 3, "numOfServices", doctor.services.length)}>
                                                    {this.props.numOfServices === 3 ?
                                                        "+ "
                                                        + (doctor.services.length - this.props.numOfServices)
                                                        + ' '
                                                        + translate('show_more') :
                                                        translate('show_less')} </p>
                                            </Accordion>
                                        </div>
                                    </div> : null}
                                {/*{doctor && doctor.insurance_companies && doctor.insurance_companies.length ?*/}
                                    {/*<div className="row">*/}
                                        {/*<div className="col-md-12 no-padding">*/}
                                            {/*<Accordion box="insurance_companies">*/}
                                                {/*{incCompanies}*/}
                                                {/*<p className=" text-center cursor-pointer bolder dark-blue "*/}
                                                   {/*hidden={doctor.insurance_companies.length < this.props.numOfIncCompanies || doctor.insurance_companies.length === 5}*/}
                                                   {/*onClick={(e) => this.props.toggleShowMore(e, 5, "numOfIncCompanies", doctor.insurance_companies.length)}>*/}
                                                    {/*{this.props.numOfIncCompanies === 5 ?*/}
                                                        {/*"+ "*/}
                                                        {/*+ (doctor.insurance_companies.length - this.props.numOfIncCompanies)*/}
                                                        {/*+ ' '*/}
                                                        {/*+ translate('show_more') :*/}
                                                        {/*translate('show_less')} </p>*/}
                                            {/*</Accordion>*/}
                                        {/*</div>*/}
                                    {/*</div> : null}*/}
                                {doctor && doctor.gallery && doctor.gallery.length ?
                                    <div className="row">
                                        <div className="col-md-12 no-padding">
                                            <Accordion box="clinic_gallery">
                                                <ProfileGallery language={this.props.language} imagesList={doctor.gallery}/>
                                            </Accordion>
                                        </div>
                                    </div> : null}
                                {doctorReviews && doctorReviews.length ?
                                    <Accordion box="reviews" collapse={false} id="reviews">
                                        <div className="reviews mb-50">
                                            <Rating
                                                direction={this.props.language === 'ar' ? "rtl" : "ltr"}
                                                initialRating={doctor.rate}
                                                readonly
                                                emptySymbol="fa fa-star-o font-20 empty-star"
                                                fullSymbol="fa fa-star font-20 full-star"
                                            />
                                            <p className="doctor-reviews text-center">{doctor.reviews + " " + translate('reviews')}</p>
                                        </div>
                                        {reviews}
                                        <div className="col-md-12 text-center" hidden={noMoreReviews === true}>
                                            <div className="loading-more cursor-pointer"
                                                 hidden={doctorReviews.length < 3 || doctor.reviews === 3 || reviewsLoading === true}
                                            >
                                                <div className="text-center">
                                                    <a href="/" style={{pointerEvents: 'false'}} className="btn"
                                                       onClick={(e) => this.props.loadMoreReviews(e, 3, 0)}>{this.props.translate("fetch_more")}</a>
                                                </div>
                                            </div>

                                            <div className="loading-more reviews-loading"
                                                 hidden={reviewsLoading === false}>
                                                <div className="text-center">
                                                    <img style={{width: '100px'}} src="/images/loading.svg"
                                                         alt="loading"/>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion> : null}
                            </div>) :
                        (setDoctorProfileSkeleton())
                }
            </div>
        )
    }
};
export default withTranslate(DoctorDetails);